export default __webpack_public_path__ + "static/media/therabblewrangler.5da05ad2.mp4";